import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';

interface AchievementsModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  t: {
    achievements: string;
    description: string;
  };
}

export function AchievementsModal({ open, onOpenChange, t }: AchievementsModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t.achievements}</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <p className="text-slate-500">{t.description}...</p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
